import { useEffect, useRef, type ElementRef } from "react";
import { useTracker } from "./util/Tracker";
import styles from "./CTA_도입문의.module.css";
import { asx } from "./util/applyStyle";
import { O } from "@mobily/ts-belt";

export type CTA_도입문의Props = {
  onClick: () => void;
  activated: boolean;
};

const as = asx(styles);

export const CTA = ({ activated, onClick }: CTA_도입문의Props) => {
  const button = useRef<ElementRef<"div">>(null);
  const scrollWrapperRef = useRef<O.Option<Element>>(
    O.fromNullable(document.getElementsByClassName("content-container")[0])
  );

  const docked = useRef<boolean>(true);
  const tracker = useTracker();
  const scrollHeight = useRef(scrollWrapperRef.current?.scrollHeight ?? 0);
  const dockThreshold = useRef(0);

  const scrollEvent = () => {
    if (button.current && scrollWrapperRef.current) {
      scrollHeight.current = scrollWrapperRef.current.scrollHeight;
      dockThreshold.current = scrollHeight.current - window.innerHeight - 130;
      if (scrollWrapperRef.current.scrollTop < dockThreshold.current) {
        button.current.classList.add(as("docked"));
        docked.current = true;
      } else {
        button.current.classList.remove(as("docked"));
        docked.current = false;
      }
    }
  };

  useEffect(() => {
    scrollWrapperRef.current = O.fromNullable(
      document.getElementsByClassName("content-container")[0]
    );
    if (scrollWrapperRef.current)
      scrollWrapperRef.current.addEventListener("scroll", scrollEvent);
    return () => {
      window.removeEventListener("scroll", scrollEvent);
    };
  }, []);

  useEffect(() => {
    if (button.current) {
      if (activated) {
        button.current.classList.add(styles["activated"] ?? "");
      } else {
        button.current.classList.remove(styles["activated"] ?? "");
      }
    }
  }, [button, activated]);

  const performClick = () => {
    if (docked.current && scrollWrapperRef.current) {
      scrollHeight.current = scrollWrapperRef.current.scrollHeight;
      scrollWrapperRef.current.scrollTo({
        top: scrollHeight.current,
        behavior: "smooth",
      });
      tracker.trackingClick({
        depth1: "LEAD2",
        depth2: "모바일 도입문의폼",
      });
    } else {
      if (activated) {
        onClick();
      }
    }
  };

  return (
    <>
      <div
        className={as("cta_도입문의")}
        onClick={() => {
          performClick();
        }}
      >
        <div className={as("cta-spacer")} />
        <div ref={button} className={as("cta docked")}>
          {"도입 문의하기"}
        </div>
      </div>
    </>
  );
};
